import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LaunchModal from './LaunchModal';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <header className="bg-gray-900/80 backdrop-blur-lg border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3 group">
              <img 
                src="/logo-big.png" 
                alt="BarnBills Logo" 
                className="h-8 w-auto transition-transform group-hover:scale-105"
              />
            </Link>
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <Link 
                to="/features" 
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
              >
                Features
              </Link>
              <Link 
                to="/plugins" 
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
              >
                Plugins
              </Link>
              <Link 
                to="/pricing" 
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
              >
                Pricing
              </Link>
              <Link 
                to="/about" 
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
              >
                About
              </Link>
              <Link 
                to="/contact" 
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
              >
                Contact
              </Link>
              <div className="h-4 w-px bg-gray-700 mx-4"></div>
              
              <a 
                href="https://app.barnbills.com" 
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sign In
              </a>
              <button
                onClick={() => setIsModalOpen(true)}
                className="brand-gradient text-white px-6 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/25"
              >
                Get Notified
              </button>
            </nav>
            
            {/* Mobile menu button */}
            <button 
              className="md:hidden text-gray-300 hover:text-white transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                />
              </svg>
            </button>
          </div>
          
          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden pb-4 border-t border-gray-800 mt-4 pt-4">
              <div className="flex flex-col space-y-4">
                <Link 
                  to="/features" 
                  className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Features
                </Link>
                <Link 
                  to="/plugins" 
                  className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Plugins
                </Link>
                <Link 
                  to="/pricing" 
                  className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Pricing
                </Link>
                <Link 
                  to="/about" 
                  className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  About
                </Link>
                <Link 
                  to="/contact" 
                  className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contact
                </Link>
                
                <a 
                  href="https://app.barnbills.com" 
                  className="text-gray-300 hover:text-white transition-colors text-sm font-medium"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign In
                </a>
                <button
                  onClick={() => {
                    setIsModalOpen(true);
                    setIsMenuOpen(false);
                  }}
                  className="brand-gradient text-white px-6 py-3 rounded-lg text-sm font-medium transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/25 text-center"
                >
                  Get Notified
                </button>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Launch Modal */}
      <LaunchModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default Header; 